<!-- eslint-disable no-unused-vars -->
<style>
.block-hover{
  padding:10px 10px 0px 10px;
}
.block-hover:hover{
  box-shadow: 0px 0px 3px #00000023;
  border-radius: 5px;
}
label{
  font-weight: 800;
  color:#00000091
}
.border-right{
  border-right: 2px solid #eff2f7 !important;
}
.border-bottom{
  border-bottom: 2px solid #eff2f7 !important;
}
</style>
<script>
import Loader from "@/components/widgets/loader.vue"; 
import { notify } from '@/helpers/notify' 
import payModal from "../../components/pay_modal.vue";
import ipHistory from "./widgets/ip_history.vue";
import Ttoys from "./widgets/ttoys_modal.vue";
import { ability,onlyUserCheck } from "@/helpers/helper"

export default {
  props:[
    "data"
  ],
  components: {
    Loader,
    payModal,
    ipHistory,
    Ttoys
  },
  data() {
    return {
      dataLoading:true,
      connectionLoading:true,
      networkLoading:true,
      ttoysData:{},
      edit:'',
      forHistoryData:{},
      newNetwork:{},
      network:{},
      networkCnt:0,
      services:[],
      staticIpList:[],
      routerList:[],
      ipList:[],
      portList:[],
      connections:[],
      submitted: false,
      mainButtonColor:[
        "primary",
        "success",
        "warning",
        "danger",
        "secondary"
      ],
      ////[{id:'0',name:'Potansiyel'},{id:'1',name:'Aktifler'},{id:'2',name:'Günden Pasif'},{id:'3',name:'İptal'},{id:'4',name:'Dondurulmuş'}]"
      buttons:[
        { id:1, title: "Aktif Et" , class: "success"},
        { id:3, title: "İptal Et" , class: "danger"},
        { id:4, title: "Dondur" , class: "warning"},
        { id:5, title: "Nakil" , class: "info"},
      ],
      section:'',
      xdslNo:'',
    };
  },
  computed:{
    statusButtons(){
        if(this.data.status_id == 1 && this.checkRole('aktif-et')) return  this.buttons.filter(e => e.class != 'success')
        if(this.data.status_id == 2 ) return  this.buttons.filter(e => e.class != 'success')
        if(this.data.status_id == 3) return  []
        if(this.data.status_id == 4 && this.checkRole('iptal-et')) return  this.buttons.filter(e => e.class == 'success' || e.class == 'danger')
        return false
    }
  },
  validations: {},
  watch:{
    '$route': {
        handler: function() {
            this.dataLoading = true
            this.getConnections()
            this.getTariffs()
            this.getNetwork()    
            
            setTimeout(() => {
                this.dataLoading = false
                
            }, 500);
        },
        deep: true,
        immediate: true
     },
    networkCnt(newVal){
      if(newVal == 0) return

      if(newVal == 1){
        this.getIps('l',this.network.ports.router_id)
        if(!this.network.ips) return
      }else if(newVal <= 2){
        this.ipList =[{}]
        this.getPorts(this.network.ports.router_id)
      }else if(newVal <= 3){
        this.ipList =[{}]
        this.portList=[{}]
        this.getRouters()
      }else if(newVal == 4){ // sabit ip değişimi
        this.getIps('S');
        return false
      }
    },
    data(){
      this.getConnections()
      this.getTariffs()
      this.getNetwork()
      this.dataLoading = false
     
    }
  },
  methods: {
    networkIptal(changeType){

        if(!this.checkRole('hatport')) return false

        let gecismi = changeType == this.network.isStaticIp

        const { id } = this.$route.params

        let update ={};
        let defination ='';
        let isStaticIp =this.network.isStaticIp;


        if(!gecismi){
          if(changeType == 1){  
            delete this.newNetwork['ip_id']
            delete this.newNetwork['port_id']
            delete this.newNetwork['router_id']
            defination = 'hat&port ve lokal ip'
            isStaticIp = 1;
            update = {port_id:1}
          }else if(changeType == 0){ //
            delete this.newNetwork['static_ip_id']
            defination = 'statik ip'
            isStaticIp =  0;
            update = {statik_ip:1}
          }
          
       
        if(this.network.ips == null && this.network.ports == null  ){
           this.network.isStaticIp = changeType;
          return
        }


        this.$swal.fire({
            title: `Müşterideki ${defination} sinilenecek?`,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sil',
            denyButtonText: `Vazgeç`,
          }).then((result) => {
            if (result.isConfirmed) {
                this.$http.post(`/members/${id}/network/delete`, { ...update })
                .then(() => {
                  this.getNetwork()
                  this.$swal.fire('Başarılı Silindi', '', 'success')
                  this.edit='';
                  this.networkCnt=0
                  //this.network.isStaticIp = !isStaticIp; // ters kural eklemek için ters aç
                  
                })
                .catch(error => error)
            } else if (result.isDenied) { // silme istenmezse aynı kal
                //this.network.isStaticIp = !isStaticIp;
            }
          });
        }
    },
    async getNetwork(){
      this.network = {}
      if(!this.data.id) return 

      this.networkLoading = true
      await this.$http.post(`/members/getHatPortIp`, {subsId: this.data.id, staticIp:this.data.static_ip})
              .then(response => {
                  this.network = response.data
                })
              .catch(error => error)
              .finally(() => this.networkLoading = false)
    },
    async getPorts(routerId){
        await this.$http.post('/ports/getByRouterId', { routerId })
        .then(resp => {this.portList = resp.data.content})
        .catch(error => error)
    },
    async getIps(type = 'S',routerId =null){
       await this.$http.post('/ips/getByRouterId', {  type,routerId })
        .then(resp => {
          if(type == 'S'){
            this.staticIpList = resp.data.content
          }else{
            this.ipList = resp.data.content
          }
        })
        .catch(error => error)
    },
    async getRouters(){
       await this.$http.post('/routers' , { output : 'only'})
        .then(resp => {
            this.routerList = resp.data
        })
    },
    async getTariffs(){
      await this.$http.post('/tariff/search',{ name:'type', val:this.data.tariff_group})
        .then(resp => {
            this.data['tarifeler'] = resp.data.content
        }) .catch(error => error)
    },
    async getConnections(){
      if(!this.data.username) return 

        this.connectionLoading = true
       const radacctUrl = `/members/${this.data.username}/connections`
        await this.$http.get(radacctUrl)
                  .then(resp => {
                     this.connections = resp.data.content
                     
                  }) .catch(error => error)
                    .finally(() => this.connectionLoading = false)
    },
    update(key){
      let obj;

      if(typeof(key) == 'object'){
          obj = [];
          obj = key.map(e => ({ key:e, val:this.data[e] }));
       }else{
           obj = {};
           obj['key'] =  key;
           obj['val'] =  this.data[key];
      }
      const { id } = this.$route.params
      this.$http.put(`/members/${id}/updateSubscriber`,obj )
        .then(resp => {
          if(resp.data.error) return notify.error(resp.data.message)
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    async paketUzat() {
      const { id } = this.$route.params
      await this.$http.post(`members/${id}/services`)
        .then(resp => {
           this.services= {
              invoice_items : resp.data.content.items,
              user : resp.data.content.user,
            }

          this.$bvModal.show('pay-modal')
        })
        .catch(error => error)
    }, 
    async kick(username) {
      if(this.connectionLoading) return
      this.connectionLoading = true
      await this.$http.get(`members/${username}/kick`)
        .then(resp => {
            if(resp.data.error) return notify.error(resp.data.message)

            this.getConnections()
            notify.success(resp.data.message)
        })
        .catch(error => error)
        .finally(() => this.connectionLoading = false)
    },
    async statusChange(statusId) {
      const { id } = this.$route.params

      let confirmLabel = ''
      if(statusId == 1) confirmLabel = 'aktif etmek'
      if(statusId == 3) confirmLabel = 'iptal etmek'
      if(statusId == 4) confirmLabel = 'dondurmak'
      if(statusId == 5) confirmLabel = 'nakil etmek'


      this.$swal.fire({
          title: `Müşteriyi ${confirmLabel} istiyormusunuz?`,
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Onay',
          denyButtonText: `Vazgeç`,
        }).then((result) => {
          if (result.isConfirmed) {
             this.$http.post(`members/${id}/changeStatus/${statusId}`)
                  .then(resp => { 
                    notify.success(resp.data.message)
                      setTimeout(()=>{
                        location.href=window.location.href;
                      },2000)
                    })
                  .catch(error => error)
          } else if (result.isDenied) { 
              //this.network.isStaticIp = !isStaticIp;
          }
        });

    },
    networkSave(){
      const { id } = this.$route.params
      this.$http.post(`/members/${id}/network/update`, { ...this.newNetwork })
        .then(() => {
          this.getNetwork()
          this.networkCnt=0
          this.$swal.fire('Başarılı Güncellendi', '', 'success')
      })
    },
    setSelected(val,method){
      if(method=='getPort'){
       
        this.getPorts(val.id)
        this.data.router_id = val
        return
      }

      if(method=='getIp')
        this.getIps( 'l',this.network.ports ? this.network.ports.router_id : this.newNetwork.router_id)
    },
    openIphistory(){
      const { id } = this.$route.params
      this.$bvModal.show('ip_modal')
      this.forHistoryData = id
    },
    checkRole(role){
      return ability(role)
    },
    checkAdmin(){
      return onlyUserCheck("admin")
    },
    ttoysModal(){
      //this.ttoysData = { xdslNo:this.data.xdsl_num }
      this.section = 'ttoys'
      this.xdslNo = this.data.xdsl_num
      this.$bvModal.show('ttoys_modal')
    },
    hatModal(){
      this.section = 'hat'
      this.xdslNo = this.data.xdsl_num
      this.$bvModal.show('ttoys_modal')
    },

    expireLabel(data){
      return data < 0 ? `Bitiş tarihi: ${this.data.expiredate_string}  ${Math.abs(data)} Gün Önce Bitmiş` : `Bitiş tarihi: ${this.data.expiredate_string} ${data} Gün` 
    }
  },
};
</script>

<template>
<div>
  <pay-modal :data="data" :services="services"/>
  <ip-history :network="forHistoryData" />
    <Ttoys 
      :xdslno="xdslNo"
      :section="section"
    />
    <Loader :loading="true" :load="dataLoading">
      <div class="fieldset" >
        <div class="legend text-light" :class="`bg-${ mainButtonColor[ data.status_id] }`" >{{ data.status }}</div>
        <div v-if="data.status_id == 4 || data.status_id == 3">
            <div class="alert alert-danger mb-0" role="alert">
              Abonelik  <b>{{ data.cancel_date_string }}</b> Tarihinde {{ data.status_id == 4 ? 'Dondurulmuştur' : data.status_id == 3 ? 'İptal Edilmiştir' : '' }}.
            </div>
        </div>
        <div class="row" v-else>
          <div class="d-flex justify-conten-between align-items-center">
            <div class="col-12 d-flex justify-content-between align-items-center p-2" style="border:dashed 2px #ededed;border-radius:5px">
              <div> {{ expireLabel(data.expireday) }} </div>
              <div class="d-flex">
                <div
                  class="me-2"
                  v-if="(data.status_id == 1 || data.status_id == 2) && ( data.invoice_type == 1 || data.invoice_type == 4  )">
                  <b-button block variant="outline-light" @click="paketUzat()">Paket Uzat</b-button>
                </div>
                <div class="row">
                  <div class="d-grid text-end">
                    <b-dropdown
                    variant="outline-light"
                    block
                    right
                    menu-class="dropdown-menu-end"
                  >
                    <template v-slot:button-content>
                      İşlemler <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                    </template>
                    <b-dropdown-item
                      class="notify-item"
                      v-for="(button,i) in statusButtons" 
                      :key="`Lang${i}`"
                      :value="button.id"
                        @click="statusChange(button.id)"
                    >
                      <span class="align-middle">{{ button.title }}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-if="statusButtons.length>0">
              <div class="row">
                <div class="d-grid text-end">
                  <b-dropdown
                  variant="outline-primary"
                  block
                  right
                  menu-class="dropdown-menu-end"
                >
                  <template v-slot:button-content>
                    İşlemler <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                  </template>
                  <b-dropdown-item
                    class="notify-item"
                    v-for="(button,i) in statusButtons" 
                    :key="`Lang${i}`"
                    :value="button.id"
                      @click="statusChange(button.id)"
                  >
                    <span class="align-middle">{{ button.title }}</span>
                  </b-dropdown-item>
                </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader :loading="true" :load="connectionLoading" v-if="data.status_id == 1">
          <div class="col-md-12 mt-2">
            <div class="d-flex justify-content-between align-items-center alert alert-success"  v-if="connections.length > 0 && connections[0].acctstoptime == null"> 
              <div><i class="mdi mdi-account-check"></i> Bağlantı Aktif (online)</div>
              <div class="col-md-auto">
                <button 
                  @click="kick(data.username)"
                  type="button" 
                  class="btn btn-sm btn-outline-danger" 
                  >
                  <i class="mdi mdi-connection font-size-16"></i> Bağlantıyı Kes
                </button>
              </div>
            </div>
            <div v-else class="alert alert-danger mb-0"><i class="mdi mdi-account-cancel me-3"></i> Bağlantı Pasif</div>
          </div>
       </Loader>
      </div> 
    </Loader>
  <Loader :loading="true" :load="dataLoading">
    <div class="card">
      <div class="card-body">  
        <div class="row border-bottom">
          <div class="col-md-6 block-hover">
            <div class="mb-3">
              <label>Hizmet Grubu</label> 
              <p>
                <span v-if="data.tariff_group != 'WIFI'" class="badge badge-pill badge-soft-success font-size-13">Vae</span> 
                <span v-else class="badge badge-pill badge-soft-info font-size-13">Wifi</span> 
              </p>
            </div>
          </div>
          <div class="col-md-6" v-if="data.tariff_group != 'WIFI'">
            <div class="row align-self-center">
              <div class="col-md-6">
                <button 
                type="button" 
                style="width:100%"
                @click="ttoysModal()"
                :class="`btn btn-outline-light btn-block`">
                  <i class="bx bx-selection"></i>
                   <br/>
                  Ttoys
                </button>
              </div>
              <div class="col-md-6">
                <button 
                type="button"  
                style="width:100%"
                @click="hatModal()"
                :class="`btn btn-outline-light btn-block`">
                 <i class="bx bx-wifi-off"></i>
                  <br/>
                  Hat Sinyal Sorgula
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom">
            <div class="col-md-6 block-hover border-right">
                <div class="mb-3">
                    <label>Hizmet No</label>
                    <p>
                      <span v-if="edit == 'service_num'">
                        <div class="input-group">
                          <input type="text" v-model="data.service_num" class="form-control form-control-sm">
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('service_num'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.service_num }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'service_num'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
           <div class="col-md-6 block-hover" v-if="data.tariff_group != 'WIFI'">
                <div class="mb-3">
                    <label>Xdsl No</label>
                    <p>
                      <span v-if="edit == 'xdsl_num'">
                        <div class="input-group">
                          <input type="text" v-model="data.section" class="form-control form-control-sm">
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('xdsl_num'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.xdsl_num }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'xdsl_num'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="row border-bottom">
          <div class="col-md-6  block-hover border-right" v-if="checkAdmin()">
            <div class="mb-3">
                <label>Bayisi</label>
                <p>
                  <span v-if="edit == 'user_id'">
                    <div class="input-group">
                      <select v-model="data.user_id"  @change="data.user_name = $event.target.options[$event.target.selectedIndex].text" class="form-select form-select-sm" >
                        <option :value="bayi.id" v-for="bayi in data.bayiList" :key="bayi.id">{{ bayi.name }}</option>
                      </select>
                      <button class="btn btn-success btn-sm" type="button" @click.prevent="update('user_id'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                      <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                    </div>
                  </span>
                  <span v-else>
                      {{ data.user_name || '-' }} 
                      <span class="float-end">
                        <a href="#" @click.prevent="edit = 'user_id'">
                            <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                        </a>
                    </span>
                  </span>
                </p>
            </div>
          </div>
          <div class="col-md-6  block-hover">
                <div class="mb-3">
                    <label>Müşteri Grubu</label>
                    <p>
                      <span v-if="edit == 'group_id'">
                        <div class="input-group">
                          <select v-model="data.group_id"  @change="data.group_name = $event.target.options[$event.target.selectedIndex].text" class="form-select form-select-sm" >
                            <option :value="group.id" v-for="group in data.groupList" :key="group.id">{{ group.name }}</option>
                          </select>
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('group_id'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.group_name || '-' }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'group_id'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="row border-bottom">
            <div class="col-md-6 border-right block-hover">
              <div class="mb-3">
                  <label>Üyelik Tarihi</label>
                  <p>
                    <span v-if="edit == 'start_date'">
                      <div class="input-group">
                        <input type="datetime-local" v-model="data.start_date" class="form-control form-control-sm">
                        <button class="btn btn-success btn-sm" type="button" @click.prevent="update('start_date'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                        <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                      </div>
                    </span>
                    <span v-else>
                        {{ data.start_date_string }} 
                        <span class="float-end">
                          <a href="#" @click.prevent="edit = 'start_date'">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </span>
                    </span>
                  </p>
              </div>
            </div>
            <div class="col-md-6 block-hover">
                <div class="mb-3">
                    <label>Üyelik Bitiş Tarihi</label>
                    <p>
                      <span v-if="edit == 'expiredate'">
                        <div class="input-group">
                          <input type="datetime-local" v-model="data.expiredate" class="form-control form-control-sm">
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('expiredate'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.expiredate_string }}  ({{ data.expireday }} Gün)
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'expiredate'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="row border-bottom">
            <div class="col-md-6 border-right block-hover">
                <div class="mb-3">
                  <label>Hizmet Tipi</label>
                    <p>
                    <span>
                        {{ data.invoice_type_format }} 
                    </span>
                  </p>
              </div>
            </div>
           <div class="col-md-6 block-hover">
              <div class="mb-3" v-if="data.invoice_type == 2 || data.invoice_type == 3">
                <label>Fatura Dönemi</label>
                <p>
                    <span v-if="edit == 'invoice_period'">
                      <div class="input-group">
                          <select 
                            class="form-select form-select-sm" 
                            v-model="data.invoice_period"
                          > 
                            <option 
                            :value="i"   
                            v-for="i in 28"
                            :key="i">
                              Her Ayın <b>{{ i }}</b> . Günü Fatura Oluşacak
                            </option>
                          </select>
                        <button class="btn btn-success btn-sm" type="button" @click.prevent="update('invoice_period'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                        <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                      </div>
                    </span>
                    <span v-else>
                         Her Ayın <b>{{ data.invoice_period }} </b> . Günü Fatura Oluşacak
                        <span class="float-end">
                          <a href="#" @click.prevent="edit = 'invoice_period'">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </span>
                    </span>
                  </p>
              </div>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-md-6 border-right block-hover">
              <div class="mb-3">
                    <label>Tarife Tipi</label>
                      <p>
                      <span v-if="edit == 'tariff_id'">
                        <div class="input-group">
                            <select class="form-select form-select-sm" v-model="data.tariff_group">
                              <option value="">Seçiniz</option>
                              <option value="ADSL">ADSL</option>
                              <option value="XDSL">XDSL</option>
                              <option value="FIBER">Fiber</option>
                              <option value="HIPER">Hiper</option>
                              <option value="METRO">Metro</option>
                              <option value="WIFI">WiFi</option>
                            </select>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.tariff_group }} 
                      </span>
                    </p>
                </div>
            </div>
            <div class="col-md-6 block-hover">
              <div class="mb-3">
                  <label>Tarife Adı</label>
                  <p>
                    <span v-if="edit == 'tariff_id'">
                      <div class="input-group">
                          <select class="form-select form-select-sm" v-model="data.tariff_id"> 
                            <option :value="tarife.id" v-for="tarife in data.tarifeler" :key="tarife.id">{{ tarife.name }}</option>
                          </select>
                        <button class="btn btn-success btn-sm" type="button" @click.prevent="update(['tariff_id','tariff_group']),edit = ''"> <i class="mdi mdi-check"></i> </button>
                        <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                      </div>
                    </span>
                    <span v-else>
                        {{ data.tariff_name }} 
                        <span class="float-end">
                          <a href="#" @click.prevent="edit = 'tariff_id'">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </span>
                    </span>
                  </p>
              </div>
            </div>
        </div>
        <div class="row border-bottom">
            <div class="col-md-6 border-right block-hover">
              <div class="mb-3">
                    <label>Özel Tarife Fiyatı</label>
                      <p>
                      <span v-if="edit == 'price'">
                        <div class="input-group">
                          <input type="number" v-model="data.price" class="form-control form-control-sm">
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('price'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.price }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'price'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
            <div class="col-md-6 block-hover">
              <div class="mb-3">
                  <label>Hız Geçersizleştir (Mbps)</label>
                    <p>
                    <span v-if="edit == 'speed'">
                      <div class="d-flex">
                        <div class="col-6">
                           <input type="number" v-model="data.speedupload" class="form-control form-control-sm" placeholder="Upload">
                        </div>
                        <div class="col-6">
                          <div class="input-group">
                            <input type="text" v-model="data.speeddownload" class="form-control form-control-sm" placeholder="Download">
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update(['speedupload','speeddownload']),edit = ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span v-else>
                         {{ data.speedupload }} / {{ data.speeddownload }} 
                        <span class="float-end">
                          <a href="#" @click.prevent="edit = 'speed'">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </span>
                    </span>
                  </p>
              </div>
            </div>
        </div>
        <div class="row border-bottom">
            <div class="col-md-6 border-right block-hover">
                <div class="mb-3">
                    <label>Kullanıcı Adı</label>
                      <p>
                      <span v-if="edit == 'username'">
                        <div class="input-group">
                          <input type="text" v-model="data.username" class="form-control form-control-sm">
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('username'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.username }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'username'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
            <div class="col-md-6 block-hover">
                <div class="mb-3">
                    <label>Şifre</label>
                      <p>
                      <span v-if="edit == 'password'">
                        <div class="input-group">
                          <input type="text" v-model="data.password" class="form-control form-control-sm">
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('password'),edit = ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ data.password }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="edit = 'password'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12 block-hover">
            <div class="mb-3">
                <label>Bağlantı Adresi</label>
                  <p>
                    <span v-if="edit == 'address'">
                      <div class="input-group">
                        <input type="text" v-model="data.address" class="form-control form-control-sm">
                        <button class="btn btn-success btn-sm" type="button" @click.prevent="update(['tariff_id','tariff_group']),edit = ''"> <i class="mdi mdi-check"></i> </button>
                        <button class="btn btn-danger btn-sm" type="button" @click.prevent="edit = ''"> <i class="mdi mdi-close"></i> </button>
                      </div>
                    </span>
                    <span v-else>
                        <p><span class="badge badge-pill badge-soft-info font-size-13">{{ data.bbk }}</span></p>
                        {{ data.address }} 
                        <span class="float-end">
                          <a href="#" @click.prevent="edit = 'address'">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </span>
                    </span>
                  </p>
              </div>
          </div>
        </div>
      </div>
   </div>
  </Loader>
  <Loader :loading="true" :load="networkLoading">
    <div>
    <ul class="nav nav-tabs justify-content-start">
      <li class="nav-item">
        <a class="nav-link" @click="networkIptal(0)" :class="{active:network.isStaticIp == 0 }" href="javascript:void(0);">Hat&Port&Ip</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="networkIptal(1)" :class="{active:network.isStaticIp == 1 }" href="javascript:void(0);">Sabit İp</a>
      </li>
       <li class="nav-item position-absolute" style="right:0">
        <a class="nav-link bg-warning text-light" @click="openIphistory()"  href="javascript:void(0);">İp Geçmişi</a>
      </li>
    </ul>
   <div class="card">
    <div class="card-body">
      <div class="row block-hover">
        <div class="col-md-12" style="padding-right:0px" v-if="network.isStaticIp==1">
          <div class="row">
              <div class="col-md-6">
                  <label>Sabit İp</label>
              </div>
               <div class="col-md-6">
                <div class="text-end">
                  <span v-if="network.ips">{{ network.ips.ip }} </span> 
                  <span v-else> - </span>
                  <a href="#"  @click.prevent="networkCnt=4" v-if="checkRole('hatport')">
                      <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                  </a>
                </div>
                <span v-if="networkCnt == 4">
                  <div>
                    <v-select 
                      v-model="newNetwork.static_ip_id"
                      :options="staticIpList"
                      :reduce="r => r.id"
                      label="ip"
                      >
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                          {{ option.ip }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.ip }}
                          </div>
                        </template>
                    <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                  </div>
                </span>
              </div>
          </div>
        </div>
        <div class="row" v-else-if="network.isStaticIp==0">
          <div class="col-md-6">
            <div class="mb-3">
               <div>
                  <label>Mikrotik</label>
                </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-end">
              <span v-if="network.ports"> 
                {{ network.ports.shortname  }} - {{ network.ports.nasname  }}
              </span> 
              <span v-else> - </span>
                <a href="#" @click.prevent="networkIptal(1);networkCnt=3" v-if="checkRole('hatport') && network.ports != null">
                    <i class="bx bx-trash text-danger font-size-16"></i>
                </a>
                <a href="#" @click.prevent="networkCnt=3" v-else>
                    <i class="mdi mdi-circle-edit-outline text-success font-size-16" v-if="checkRole('hatport')"></i>
                </a>
            </div>
            <v-select 
              v-if="networkCnt >2 && networkCnt < 4"
              v-model="newNetwork.router_id"
              label="nasname"
              :options="routerList"
              :reduce="r => r.id"
              @option:selecting="setSelected($event,'getPort')"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                  {{ option.shortname  }} - {{ option.nasname  }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                  {{ option.shortname  }} - {{ option.nasname  }}
                  </div>
                </template>
            <span slot="no-options">Sonuç Bulunamadı</span>
          </v-select>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <div>
                <label>Hat&Port</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-end">
              <span v-if="network.ports">{{ network.ports.ip }} | {{ network.ports.start }} - {{ network.ports.end }}</span>
              <span v-else>-</span>
              <a href="#" @click.prevent="networkCnt=2" v-if="checkRole('hatport')">
                  <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
              </a>
            </div>
            <div v-if="networkCnt > 1 && networkCnt < 4">
              <v-select 
                v-model="newNetwork.port_id"
                :options="portList"
                :reduce="r => r.id"
                label="ip"
                @option:selecting="setSelected($event,'getIp')"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                    {{ option.ip }} | {{ option.start }} - {{ option.end }} 
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                    {{ option.ip }} | {{ option.start }} - {{ option.end }} 
                    </div>
                  </template>
              <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <div>
                <label>Lokal İp</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-end">
              <span v-if="network.ips">{{ network.ips.ip  }} </span>
              <span v-else>-</span>
              <a href="#" @click.prevent="networkCnt=1" v-if="checkRole('hatport')">
                  <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
              </a>
            </div>
            <v-select 
              v-if="networkCnt >0 && networkCnt < 4"
              v-model="newNetwork.ip_id"
              :options="ipList"
              :reduce="r => r.id"
              label="ip">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                  {{ option.ip }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.ip }}
                  </div>
                </template>
              <span slot="no-options">Sonuç Bulunamadı</span>
          </v-select>
          </div>
        </div>
        <div class="col-md-12" style="padding-right:0px" v-else>
          <div class="row">
              <div class="col-md-12 text-center">
                  <label>Natlama veya Sabit İp Verilmemiş</label>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer bg-transparent border-success" v-if="networkCnt > 0">     
       <div class="d-flex justify-content-between mb-3">
          <button class="btn btn-success btn-sm" @click="networkSave()">Kaydet</button>
          <button class="btn btn-danger btn-sm" @click="edit='';networkCnt=0">Vazgeç</button>
      </div>
    </div>
  </div>
  </div>
  </Loader>

  <div v-if="connections.length < 1">
    <h6 class="alert alert-danger">Bağlantı geçmişi bulunmamaktadır.</h6>
  </div>
  <div class="card" v-else>
    <div class="card-body" >
        <h4 class="card-title">Son 
          <select name="" id="">
            <option value="">5</option>
            <option value="">15</option>
            <option value="">55</option>
          </select> Bağlantı Hareketi
        </h4>
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Oturum Tar.</th>
                <th>Veri</th>
                <th>İp</th>
                <th>Mikrotik / İp</th>
                <th>Oturum Süresi</th>
                <th>Kopma Nedeni</th>
              </tr>
            </thead>
            <tbody>
              <tr  v-for="conn in connections" :key="conn.radacctid">
                <td>
                  <div> <b>Baş : </b> {{ formatDate(conn.acctstarttime) }}</div>
                  <div> <b>Bit : </b> {{ formatDate(conn.acctstoptime) || 'Online' }}</div>
                </td>
                <td>
                  <b>Upl : </b>{{ formatBytes(conn.acctinputoctets) }} <br> 
                  <b>Dow : </b>{{ formatBytes(conn.acctoutputoctets) }}
                </td>
                <td>{{ conn.framedipaddress }}</td>
                <td>{{ conn.nasname }}<br>{{ conn.nasipaddress }}</td>
                <td>{{ secondsToDhms(conn.acctsessiontime) }}</td>
                <td>{{ conn.acctterminatecause }}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>
</div>

</template>